import { FC } from "react";
import React from "react";
import InfoIcon from "../../assets/images/info_icon.svg";
import { makeStyles } from "@material-ui/core";
import { Colors } from "../../styles";

const useStyles = makeStyles(() => ({
    infoIcon: {
        width: 40,
        height: 40,
    },
    container: {
        marginTop: 5,
        marginLeft: 20,
        marginRight: 20,
        padding: 20,
        fontFamily: "innogyWEB",
        borderWidth: "1px",
        borderStyle: "solid",
        borderRadius: 8,
        borderColor: Colors.radiantRed,
        backgroundColor: Colors.radiantRedFill,
    },
    itemRow: {
        display: "flex",
        flexDirection: "row",
        flex: 1,
        verticalAlign: "center",
        justifyContent: "center",
        alignItems: "center",
    },
    title: {
        marginLeft: 24,
        verticalAlign: "middle",
        textDecoration: "inherit",
        fontSize: 22,
        fontWeight: 500,
        alignSelf: "center",
        color: Colors.radiantRed,
    },
}));

export const ErrorBanner: FC = () => {
    const classes = useStyles();
    return (
        <div className={classes.container}>
            <div className={classes.itemRow}>
                <img alt="" className={classes.infoIcon} src={InfoIcon} />
                <span className={classes.title}>
                    Einige der benötigten Angaben sind fehlerhaft oder unvollständig.
                    <br />
                    Bitte korrigieren Sie Ihre Angaben.
                </span>
                <span style={{ marginLeft: "auto" }} />
            </div>
        </div>
    );
};
